// extracted by mini-css-extract-plugin
export default {"faqOuterContainer":"FaqLayout_faqOuterContainer__i+Gj0","faqTitle":"FaqLayout_faqTitle__oYiZj","buttonContainer":"FaqLayout_buttonContainer__dHsAx"};